import { API_AUTH } from "./common";

const DanhSachThuDeleteApi = {
  GetDanhSachThuDelete: ({
    name,
    NguoiXoa,
    dateFrom,
    dateTo,
    page,
    pageSize,
  }) => {
    return API_AUTH.get(
      `danh-sach-phieu-thu-bi-xoa?name=${name}&nguoixoa=${NguoiXoa}&dateFrom=${dateFrom}&dateTo=${dateTo}&page=${page}&pageSize=${pageSize}`,
      {}
    );
  },
  xoaPhieuThuDelete: (Id) => {
    return API_AUTH.delete(`xoa-phieu-thu-bi-xoa?Id=${Id}`, {});
  },
};

export default DanhSachThuDeleteApi;
